export function formatShortDate(date: string) {
  return (
    "20" +
    date.substring(0, 2) +
    "-" +
    date.substring(2, 4) +
    "-" +
    date.substring(4)
  );
}

export const dateFormatter = (str: any) => {
  return str;
};

export function isShortDate(date: any) {
  return date && date.length === 6 ? true : false;
}

export const addStaticTimeToDate = (dateValue: Date | null) => {
  if (dateValue != null) {
    dateValue.setHours(12);
    return dateValue;
  }
};
